module.exports = {
  src: __webpack_public_path__ + "static/media/commercial_00028.097f34fa.jpg",
  width: 6000,
  height: 7200,
  bytes: 1298135,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/commercial_00028.097f34fa.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/commercial/commercial_00028.jpg
// module id = 285
// module chunks = 0